import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { styled, Container, CustomLink, Body, ListContent } from '@teko/ds-desktop';
import { CheckOutlined } from '@teko/ds-icon';
import { useState, useEffect } from 'react';
import { __rest } from 'tslib';
import { g as getTrackingData } from './tracking-3282e302.js';

const Topbar = ({ rightMenu = [], leftMenu = [], }) => {
    return (jsx(Wrapper$1, { children: jsxs(StyledContainer, { children: [jsx(MenuWrapper, { children: leftMenu.map((item) => item) }, void 0), jsx(MenuWrapper, { children: rightMenu.map((item) => item) }, void 0)] }, void 0) }, void 0));
};
const Wrapper$1 = styled.div(({ theme }) => `
  @media print {
    display: none;
  }
  background-color: ${theme.colors.primary500};
  height: 42px;
`);
const StyledContainer = styled(Container) `
  display: flex;
  justify-content: space-between;
`;
const MenuWrapper = styled.div `
  display: flex;
  .button-text {
    font-weight: 500;
  }
`;

const TopbarButton = (_a) => {
    var { children, icon, href, tracking } = _a, rest = __rest(_a, ["children", "icon", "href", "tracking"]);
    return (jsx(CustomLink, Object.assign({ href: href }, { children: jsxs(Button, Object.assign({}, (tracking && getTrackingData(tracking)), rest, { children: [icon && (jsxs(Fragment, { children: [icon, jsx(Spacer, {}, void 0)] }, void 0)), jsx(Body, Object.assign({ level: 1, color: "white" }, { children: children }), void 0)] }), void 0) }), void 0));
};
const Spacer = styled.span `
  width: 0.5rem;
`;
const Button = styled.button `
  padding: 0rem 1.25rem;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  height: 42px;
  &:focus {
    outline: none;
  }
`;

const TopbarDropdown = ({ value, selectValue, options, href, tracking, }) => {
    const [show, setShow] = useState(false);
    const [activeOption, setActiveOption] = useState(options.find((option) => option.value === value));
    useEffect(() => {
        setActiveOption(options.find((option) => option.value === value));
    }, [value, options]);
    return (jsx(CustomLink, Object.assign({ href: href }, { children: jsxs(Wrapper, Object.assign({ onMouseLeave: () => setShow(false) }, { children: [jsx(TopbarButton, Object.assign({ icon: activeOption === null || activeOption === void 0 ? void 0 : activeOption.icon }, (tracking && getTrackingData(tracking)), { onMouseOver: () => setShow(true) }, { children: activeOption.text }), void 0), jsx(DropdownMenu, Object.assign({ show: show }, { children: options.map((item, index) => (jsxs(Option, { children: [jsx(StyledListContent, { label: item.text, icon: item === null || item === void 0 ? void 0 : item.icon, borderRadius: "s", onClick: () => selectValue(item.value) }, void 0), item.value === (activeOption === null || activeOption === void 0 ? void 0 : activeOption.value) && (jsx(CheckOutlined, { size: 24, color: "red", style: { position: 'absolute', right: '8px' } }, void 0))] }, index))) }), void 0)] }), void 0) }), void 0));
};
const Wrapper = styled.div `
  position: relative;
`;
const DropdownMenu = styled.div `
  display: ${(props) => (props.show ? 'block' : 'none')};
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  top: 35px;
  z-index: 10000;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  min-width: 11rem;
`;
const Option = styled.div `
  display: flex;
  align-items: center;
  position: relative;
`;
const StyledListContent = styled(ListContent) `
  cursor: pointer;
  width: 100%;
  padding: 8px 48px 8px 12px;
`;

export { Topbar as T, TopbarButton as a, TopbarDropdown as b };
